const DEFAULT_VALUES = {
  amount: 15000,
  duration: 6,
  interest: 9,
  effectiveInterest: 9.38,
  totalCost: 19468,
  monthlyCost: 270,
  installmentMonths: 72,
  startupFee: 0,
  monthlyFee: 0,
  cost: 4468
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const INTEREST = 10

// ? ******************************************************************************************
// ? ******************************************************************************************

const INTERESTS = [
  {
    amount: 0,
    interestRate: 10,
    startupFee: 0,
    monthlyFee: 0
  },
  {
    amount: 10000,
    interestRate: 9.5,
    startupFee: 0,
    monthlyFee: 0
  },
  {
    amount: 12500,
    interestRate: 9,
    startupFee: 0,
    monthlyFee: 0
  },
  {
    amount: 17500,
    interestRate: 8,
    startupFee: 0,
    monthlyFee: 0
  },
  {
    amount: 22500,
    interestRate: 7,
    startupFee: 0,
    monthlyFee: 0
  },
  {
    amount: 25000,
    interestRate: 6.5,
    startupFee: 0,
    monthlyFee: 0
  },
  {
    amount: 30000,
    interestRate: 6,
    startupFee: 0,
    monthlyFee: 0
  },
  {
    amount: 35000,
    interestRate: 5.5,
    startupFee: 0,
    monthlyFee: 0
  },
  {
    amount: 40000,
    interestRate: 5,
    startupFee: 0,
    monthlyFee: 0
  },
  {
    amount: 50000,
    interestRate: 5,
    startupFee: 0,
    monthlyFee: 0
  }
]

// ? ******************************************************************************************
// ? ******************************************************************************************

const DISCLAIMER = {
  fi: '<p>*Esimerkkikorko: Luoton ollessa {amount}, {duration} v. laina-ajalla, on kuukausierä {monthlyCost} / {installmentMonths} kk ajan. Tällöin luoton kokonaiskulut on {totalCost}, nimelliskorko {interest} ja todellinen vuosikorko {effectiveInterest} (sis. {monthlyFee} laskutuslisän ja avausmaksun {startupFee}). Luotonmyöntäjien lainasummat vaihtelee {minAmount}-{maxAmount}, nimelliskorko 4,41–20 % (todellinen vuosikorko 4,5-38 %) ja laina-aika {minDuration}–{maxDuration} v. välillä.</p><p>Luotonmyöntäjät käsittelevät kaikki hakemukset automaattisesti varmistaakseen nopeat ja vastuulliset luottopäätökset.</p>',
  en: '<p>*Esimerkkikorko: Luoton ollessa {amount}, {duration} v. laina-ajalla, on kuukausierä {monthlyCost} / {installmentMonths} kk ajan. Tällöin luoton kokonaiskulut on {totalCost}, nimelliskorko {interest} ja todellinen vuosikorko {effectiveInterest} (sis. {monthlyFee} laskutuslisän ja avausmaksun {startupFee}). Luotonmyöntäjien lainasummat vaihtelee {minAmount}-{maxAmount}, nimelliskorko 4,41–20 % (todellinen vuosikorko 4,5-38 %) ja laina-aika {minDuration}–{maxDuration} v. välillä.</p><p>Luotonmyöntäjät käsittelevät kaikki hakemukset automaattisesti varmistaakseen nopeat ja vastuulliset luottopäätökset.</p>'
}

// ? ******************************************************************************************
// ? ******************************************************************************************

module.exports = {
  DEFAULT_VALUES,
  INTEREST,
  INTERESTS,
  DISCLAIMER
}
